import React from 'react';
import GenericPopup from '../GenericPopup/GenericPopup';

const PopUpInfo = ({ onClose }) => {
  return (
    <GenericPopup onClose={onClose} showCloseButton={false}>
      <img src="/image.png" alt="Card Information" className="popup-image" />
    </GenericPopup>
  );
};

export default PopUpInfo;
